import React from 'react';
import PropTypes from 'prop-types';

import styles from './paramsCardsDate/paramsCardsDate.module.scss';

export const ParamsCardsDate = ({ className = '', date }) => {
  return (
    <div className={`${styles.date} ${className}`}>
      <span className={styles.dateValue}>
        {date}
      </span>
    </div>
  );
};

ParamsCardsDate.propTypes = {
  className: PropTypes.string,
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};
